(() => {
  angular
    .module('complianceFrameworkApp.complianceFramework')
    .controller('FisController',  FisController);

  /* ngInject */
  function FisController($filter, $location, $state, $stateParams, fiService, productService, sessionService, usStates) {
    const vm = this;

    vm.currentPage = $stateParams.currentPage || 1;
    vm.enabled = null;
    vm.fis = [];
    vm.fiType = null;
    vm.getFis = getFis;
    vm.loading = false;
    vm.newFi = newFi;
    vm.query = '';
    vm.search = search;
    vm.selectFi = selectFi;
    vm.selectOrderBy = selectOrderBy;
    vm.sessionService = sessionService;
    vm.orderBy = 'name';
    vm.orderByReverse = false;
    vm.pageChange = pageChange;
    vm.productIds = [];
    vm.products = [];
    vm.state = null;
    vm.states = usStates;
    vm.totalCount = null;

    activate();

    function activate() {
      vm.getFis();
      getProducts();
    }

    function getFis() {
      vm.loading = true;

      let params = {
        query: vm.query,
        page: vm.currentPage,
        enabled: vm.enabled,
        fi_type: vm.fiType,
        state: vm.state,
        product_ids: vm.productIds
      };

      fiService(sessionService.getAuthToken()).query(params, getFisSuccess);
    }

    function getFisSuccess(response) {
      vm.loading = false;
      vm.fis = response.data;
      vm.totalCount = parseInt(response.headers['x-total']);
    }

    function getProducts() {
      productService(sessionService.getAuthToken()).query(response => {
        vm.products = response;
      });
    }

    function newFi() {
      $state.go('application.compliance_framework.new_fi');
    }

    function pageChange(newPageNumber, _oldPageNumber) {
      vm.fis = [];
      vm.currentPage = newPageNumber;
      vm.getFis();
      setLocation();
    }

    function search() {
      vm.fis = [];
      vm.currentPage = 1;
      getFis();
    }

    function selectFi(fi) {
      $state.go('application.compliance_framework.edit_fi', {fiId: fi.id});
    }

    function selectOrderBy(key) {
      if (key == vm.orderBy) {
        vm.orderByReverse = !vm.orderByReverse;
      } else {
        vm.orderBy = key;
        vm.orderByReverse = false;
      }
    }

    function setLocation() {
      $location.search({
        currentPage: vm.currentPage
      });
    }
  }
})();
